<template>
  <div>
      <section class="section transfer" v-if="keyd=='001288'"><!--stati uniti:001288-->
        <h2 class="vb-heading mb-4">Trasferimento</h2>
        <b-row>
          <b-col cols="12">
            <p>
              I pacchetti per gli Stati Uniti non includono il trasferimento.
            </p>
          </b-col>
        </b-row>
      </section>
      <section class="section transfer" v-if="keyd=='000206' || keyd=='000534' || keyd=='000933'"><!--grecia:000206 || sardegna:000534 || minorca:000933-->
        <h2 class="vb-heading mb-4">Trasferimento</h2>
        <b-row>
          <b-col cols="12">
            <p>
              Il pacchetto potrebbe non includere il trasferimento. Per maggiori informazioni, contatta la nostra assistenza.
            </p>
          </b-col>
        </b-row>
      </section>
  </div>
</template>

<script>
//import Card from '@library/blocks/card'

export default {
  name: 'transfer',

  props: {
    keyd: String
  },

  components: {
    //'vb-card': Card,
  },

  data() {
    return {
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

  .transfer {
    background-color: $white;
    border-radius: $border-radius-lg;
    padding: $grid-gutter-width;
  }

</style>